<!-- this should be deleted once the new dashboard is ready -->
<!-- <app-content *ngIf="!isRevampEnabled"></app-content> -->
<!--  -->



<!-- below the new design -->
<main *ngIf="showContent" class="bg-[#F5F5F5] min-h-screen">
<nav class="fixed top-0 w-full bg-white z-[1]" style="box-shadow: 0px 0px 2px #0000000D;
">
    <div [class.pointer-events-none-custom]="isUpdateRequiredPage" class="px-3 py-5 ltr:lg:pr-[26px] ltr:lg:pl-[308px] rtl:lg:pl-[26px] rtl:lg:pr-[308px]">
      <div class="flex flex-row items-center justify-between">
        <div class="w-full flex items-center justify-start">
          <button data-drawer-target="logo-sidebar" (click)="isSideMenuEnabled = !isSideMenuEnabled" data-drawer-toggle="logo-sidebar" aria-controls="logo-sidebar" type="button" class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200">
              <span class="sr-only">Open sidebar</span>
              <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                 <path clip-rule="evenodd" fill-rule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
              </svg>
           </button>
           <div class="hidden sm:block">
               <p class="text-xl font-semibold">{{pageTitle | translate}}</p>
               <p class="text-xs text-[#7C7C7C]" *ngIf='pageTitle !== "admin.my-profile"'>{{userDetails?.firstName}} {{userDetails?.lastName}}</p>
           </div>
        </div>
        <div class="flex items-center gap-4 whitespace-nowrap">
         <div *ngIf="isMainAccount && userWalletAmmount?.isSuccess && !currentBalanceStopped && !loaderEnabledAmount" class="hidden sm:block">
        <div class="flex flex-row" *ngIf="userData?.siteUsersID && userWalletAmmount?.isSuccess && !currentBalanceStopped && !loaderEnabledAmount">
          <div
            class="bg-[#009933] transform ltr:skew-x-[-30deg] rtl:skew-x-[30deg] h-[30px]"
          >
            <div class="ltr:skew-x-[30deg] rtl:skew-x-[-30deg]">
              <p
                [routerLink]="'/dashboard/topup-buy' | routeLocalization"
                class="px-5 py-1 tracking-normal text-center underline font-Poppins-Light text-base leading-[25px] text-white cursor-pointer -mt-0.5"
              >
                {{ "DASHBOARD.TOPUP" | translate }}
              </p>
            </div>
          </div>

          <div
            class="bg-[#003399] ltr:skew-x-[-30deg] rtl:skew-x-[30deg] h-[30px]"
          >
            <div
              class="ltr:skew-x-[30deg] rtl:skew-x-[-30deg] flex flex-row gap-3 px-3 items-center"
            >
              <p
                class="py-1 tracking-normal font-semibold text-lg text-white mt-[-3px] min-w-[59px]"
              >
                {{ "CURRENCIES.QR" | translate }}
                  {{ isIconClicked ? formattedAmount : maskedAmount }}
              </p>
              <app-svg
                (click)="toggleIcon()"
                textClass=""
                src="assets/svgs/{{
                  isIconClicked ? 'eye-closed.svg' : 'eye-svgrepo.svg'
                }}"
                customClass="mt-[-3px] flex items-center cursor-pointer"
                label="title_goes_here"
                [stretch]="false"
                width="24"
                height="24"
                stroke="#fff"
              ></app-svg>
            </div>
          </div>
        </div>
          </div>
            <!-- <div class="flex items-center">
              <div>
                <button (click)="isNotificationListEnabled = !isNotificationListEnabled" type="button" class="flex items-center justify-center rounded-full focus:ring-4 focus:ring-gray-300 border border-solid border-[#F5F5F5] w-[30px] h-[30px] relative" aria-expanded="false" data-dropdown-toggle="dropdown-user">
                  <svg fill="#000000" width="16px" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10,20h4a2,2,0,0,1-4,0Zm8-4V10a6,6,0,0,0-5-5.91V3a1,1,0,0,0-2,0V4.09A6,6,0,0,0,6,10v6L4,18H20Z"/></svg>
                  <span class="min-w-[14px] h-[13px] pt-px absolute -top-1 -right-1 bg-[#E73C3E] rounded-full font-medium text-[10px] text-white flex items-center justify-center">{{notifications.length}}</span>
                </button>
              </div>
              <div [class.active-notification]="isNotificationListEnabled" class="z-50 hidden my-4 text-base list-none bg-white divide-y divide-gray-100 rounded-sm shadow-sm max-w-[282px] h-auto max-h-[374px] overflow-auto absolute ltr:right-2.5 rtl:left-2.5 top-[60px]" id="dropdown-user">
                <ul class="py-1" role="none">
                  
                  <li *ngFor="let notification of notifications" (click)="isNotificationListEnabled = false;" class="border-b border-solid border-[#ECECEE]">
                    <a [routerLink]="notification.link | routeLocalization" class="block pb-[18px] pt-[14px] text-sm text-gray-700 hover:bg-gray-100 px-4" role="menuitem">
                     <p class="text-xs mb-1 text-black">{{notification.title}}</p>
                     <p class="text-xs text-[#7C7C7C]">{{notification.msg}}</p>
                    </a>
                  </li>

                </ul>
              </div>
            </div> -->
            <div class="flex items-center w-10 h-10">
               <div class="relative" appClickOutSide (appOutsideClick)="isUserMenuEnabled = false;">
                 <button (click)="isUserMenuEnabled = !isUserMenuEnabled" type="button" class="flex text-sm bg-white rounded-full focus:ring-4 focus:ring-gray-300 border border-solid border-[#009933]" aria-expanded="false" data-dropdown-toggle="dropdown-user">
                   <span class="sr-only">Open user menu</span>
                   <img class="w-10 h-10 !rounded-full" 
                   [defaultImage]="'loadingImage'| imageSource" [errorImage]="'errorImage'| imageSource" [lazyLoad]="getUserImage() | imageSource" alt="User Image" />
                 </button>




                 <div
                 *ngIf="isUserMenuEnabled"
                 class="absolute top-[46px] ltr:-right-0.5 rtl:-left-0.5 lg:ltr:right-0 lg:rtl:left-0 w-[calc(100vw-32px)] lg:w-[338px] h-auto bg-white z-[100] rounded-lg shadow-custom-6 max-w-[330px] lg:max-w-[unset]"
               >
                 <div class="mt-11 mb-5 mx-auto relative">
                   <img
                     class="w-[82px] mx-auto h-[82px] bg-white border-2 border-solid border-[#009933] !rounded-full"
                     [defaultImage]="'loadingImage'| imageSource" [errorImage]="'errorImage'| imageSource" [lazyLoad]="getUserImage() | imageSource"
                     alt="User Image"
                   />
                   <!-- <div
                     class="absolute rounded-full flex justify-center items-center left-0 mx-auto right-[-55px] -bottom-2.5 bg-[#CCCCCC] w-[30px] h-[30px] border-2 border-solid border-white custom-7"
                   >
                     <app-svg
                       src="assets/svgs/arrow.svg"
                       label="title_goas_here"
                       [stretch]="false"
                       width="24"
                       height="24"
                       stroke="#ffffff"
                     ></app-svg>
                   </div> -->
                 </div>
                 <div class="px-[22px]">
                   <p
                     class="text-center -mt-2.5 font-Poppins-Medium text-lg text-black whitespace-normal leading-[1.5]"
                     *ngIf="userData?.siteUsersID"
                   >
                     {{ getFullName() }}
                   </p>
                   <hr class="border-t-[#E0E0E0] mt-3 mb-2.5" />
                   <ul class="flex flex-col gap-3">
                     <ng-container *ngFor="let item of userMenu">
                     <li *ngIf="(item.link !== '/dashboard/my-wallet') || (item.link === '/dashboard/my-wallet' && isMainAccount && userWalletAmmount?.isSuccess && !currentBalanceStopped && !loaderEnabledAmount)"
                       class="flex justify-between gap-2 cursor-pointer"
                       (click)="clickOnMenuItem()"
                       [routerLink]="item.link | routeLocalization"
                     >
                       <div class="flex gap-3 items-center">
                         <app-svg
                           [src]="item.svg"
                           customClass=""
                           label="title_goas_here"
                           [stretch]="false"
                           width="24"
                           height="24"
                           [fill]="item.fill"
                         ></app-svg>
                         <span
                           class="ltr:text-left rtl:text-right font-Poppins-Light text-sm leading-5 text-[#221E20]"
                           >{{ item.title | translate }}</span
                         >
                       </div>
                       <app-svg
                         src="assets/svgs/arrow.svg"
                         customClass="ltr:rotate-[270deg] rtl:rotate-[90deg]"
                         label="title_goas_here"
                         [stretch]="false"
                         width="24"
                         height="24"
                         stroke="#000000"
                       ></app-svg>
                     </li>
                     
                     

                     </ng-container>

                     <li *ngIf="loaderEnabledAmount">
                      <div class="w-4 h-4 border-2 border-gray-300 border-t-transparent rounded-full animate-spin mx-auto"></div>
                     </li>

                     <li *ngIf="isMainAccount && !userWalletAmmount?.isSuccess && !currentBalanceStopped && !loaderEnabledAmount"
                       class="flex justify-between gap-2 cursor-pointer"
                       (click)="clickOnMenuItem()"
                       [routerLink]="'/woqode-tag' | routeLocalization"
                     >
                       <div class="flex gap-3 items-center">
                        <img src="assets/images/woqode.png" alt="" class="w-6 h-6" />
                         <!-- <app-svg
                           [src]="item.svg"
                           customClass=""
                           label="title_goas_here"
                           [stretch]="false"
                           width="24"
                           height="24"
                           [fill]="item.fill"
                         ></app-svg> -->
                         <span
                           class="ltr:text-left rtl:text-right font-Poppins-Light text-sm leading-5 text-[#221E20]"
                           >{{ 'Become_a_WOQOD_customer' | translate }}</span
                         >
                       </div>
                       <app-svg
                         src="assets/svgs/arrow.svg"
                         customClass="ltr:rotate-[270deg] rtl:rotate-[90deg]"
                         label="title_goas_here"
                         [stretch]="false"
                         width="24"
                         height="24"
                         stroke="#000000"
                       ></app-svg>
                     </li>

                   </ul>
                   <hr class="border-t-[#E0E0E0] mt-2.5 lg:mt-2.5 mb-3" />
                   <ul class="flex flex-col gap-3 mb-3">
                     <li
                       class="flex justify-between gap-2 cursor-pointer"
                       (click)="logout()"
                     >
                       <div class="flex gap-3 items-center">
                         <app-svg
                           src="assets/svgs/logout.svg"
                           customClass=""
                           label="title_goas_here"
                           [stretch]="false"
                           width="24"
                           height="24"
                           fill="#000000"
                         ></app-svg>
                         <span
                           class="ltr:text-left rtl:text-right font-Poppins-Light text-sm leading-5 text-[#221E20]"
                           >{{ "DASHBOARD.LOG_OUT" | translate }}</span
                         >
                       </div>
                       <app-svg
                         src="assets/svgs/arrow.svg"
                         customClass="ltr:rotate-[270deg] rtl:rotate-[90deg]"
                         label="title_goas_here"
                         [stretch]="false"
                         width="24"
                         height="24"
                         stroke="#000000"
                       ></app-svg>
                     </li>
                   </ul>
                 </div>
               </div>




               </div>
             </div>
          </div>
      </div>
    </div>
  </nav>
  
  <aside  [class.side-menu-enabled]="isSideMenuEnabled" id="logo-sidebar" class="fixed top-0 ltr:left-0 rtl:right-0 z-40 w-[263px] h-screen pt-5 transition-transform ltr:-translate-x-full rtl:translate-x-0 bg-white ltr:sm:translate-x-0 rtl:sm:translate-x-0" aria-label="Sidebar"
  style="box-shadow: 0px 0px 2px #00000026;"
  >
  <button [class.pointer-events-none-custom]="isUpdateRequiredPage" (click)="isSideMenuEnabled = false;" type="button" class="absolute ltr:right-[10px] rtl:left-[10px] top-[28px] sm:hidden">
   <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="white"/>
      <path d="M7 17L16.8995 7.10051" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7 7.00001L16.8995 16.8995" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
   </svg>
  </button>
      <div [class.pointer-events-none-custom]="isUpdateRequiredPage" class="pb-10">
         <img src="assets/images/woqod-logo.png" alt="" class="w-[141px] h-[36px] mx-auto cursor-pointer" [routerLink]="'/' | routeLocalization" />
      </div>
      <div [class.pointer-events-none-custom]="isUpdateRequiredPage" class="flex items-center justify-between ltr:pl-[26px] ltr:pr-[22px] rtl:pr-[26px] rtl:pl-[22px] pb-[22px]">
         <span class="text-xs text-[#7C7C7C]">{{'admin.LANGUAGE' | translate}}</span>
          <app-lang-switcher-dashboard          
          class="w-[58px] inline-block"
          [isEn]="isEn"
          (toggleLanguage)="setLang()"
          ></app-lang-switcher-dashboard>
      </div>
     <div [class.pointer-events-none-custom]="isUpdateRequiredPage" class="h-[calc(100%-144px)] px-4 pb-4 overflow-y-auto bg-white overflow-x-hidden">
        <ul class="h-full flex flex-col">
           <!-- <li>
              <a [routerLink]="'/dashboard/dashboard' | routeLocalization" class="flex items-center py-[13px] px-[18px] text-[#7C7C7C] rounded-[5px]  hover:bg-gray-100 group" [class.active-item]="isLinkActive('/dashboard/dashboard')">
                 <svg class="w-5 h-5 transition duration-75" viewBox="0 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path class="svg-color-stroke" fill-rule="evenodd" clip-rule="evenodd" d="M9.918 10.0005H7.082C6.66587 9.99708 6.26541 10.1591 5.96873 10.4509C5.67204 10.7427 5.50343 11.1404 5.5 11.5565V17.4455C5.5077 18.3117 6.21584 19.0078 7.082 19.0005H9.918C10.3341 19.004 10.7346 18.842 11.0313 18.5502C11.328 18.2584 11.4966 17.8607 11.5 17.4445V11.5565C11.4966 11.1404 11.328 10.7427 11.0313 10.4509C10.7346 10.1591 10.3341 9.99708 9.918 10.0005Z" stroke="#7C7C7C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path class="svg-color-stroke" fill-rule="evenodd" clip-rule="evenodd" d="M9.918 4.0006H7.082C6.23326 3.97706 5.52559 4.64492 5.5 5.4936V6.5076C5.52559 7.35629 6.23326 8.02415 7.082 8.0006H9.918C10.7667 8.02415 11.4744 7.35629 11.5 6.5076V5.4936C11.4744 4.64492 10.7667 3.97706 9.918 4.0006Z" stroke="#7C7C7C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path class="svg-color-stroke" fill-rule="evenodd" clip-rule="evenodd" d="M15.082 13.0007H17.917C18.3333 13.0044 18.734 12.8425 19.0309 12.5507C19.3278 12.2588 19.4966 11.861 19.5 11.4447V5.55666C19.4966 5.14054 19.328 4.74282 19.0313 4.45101C18.7346 4.1592 18.3341 3.9972 17.918 4.00066H15.082C14.6659 3.9972 14.2654 4.1592 13.9687 4.45101C13.672 4.74282 13.5034 5.14054 13.5 5.55666V11.4447C13.5034 11.8608 13.672 12.2585 13.9687 12.5503C14.2654 12.8421 14.6659 13.0041 15.082 13.0007Z" stroke="#7C7C7C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path class="svg-color-stroke" fill-rule="evenodd" clip-rule="evenodd" d="M15.082 19.0006H17.917C18.7661 19.0247 19.4744 18.3567 19.5 17.5076V16.4936C19.4744 15.6449 18.7667 14.9771 17.918 15.0006H15.082C14.2333 14.9771 13.5256 15.6449 13.5 16.4936V17.5066C13.525 18.3557 14.2329 19.0241 15.082 19.0006Z" stroke="#7C7C7C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                 </svg>
                 <span class="ms-3 font-semibold text-sm">{{'admin.Dashboard' | translate}}</span>
              </a>
           </li> -->

           <li>
            <a (click)="closeMenuInMobile()" [routerLink]="'/dashboard/my-profile' | routeLocalization" class="flex items-center py-[13px] px-[18px] text-[#7C7C7C] rounded-[5px]  hover:bg-gray-100 group" [class.active-item]="isLinkActive('/dashboard/my-profile')">
               <svg class="w-5 h-5 text-[#7C7C7C] transition duration-75" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path class="svg-color-stroke" d="M5 21C5 17.134 8.13401 14 12 14C15.866 14 19 17.134 19 21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="#7C7C7C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
               <span class="ms-3 font-semibold text-sm">{{'admin.My_Profile' | translate}}</span>
            </a>
         </li>

         <!-- <li>
            <a [routerLink]="'/dashboard/my-vehicles' | routeLocalization" class="flex items-center py-[13px] px-[18px] text-[#7C7C7C] rounded-[5px]  hover:bg-gray-100 group" [class.active-item]="isLinkActive('/dashboard/my-vehicles')">
               <svg class="w-5 h-5 text-[#7C7C7C] transition duration-75" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path class="svg-color" d="M15.7993 3C17.2899 3 18.5894 4.01393 18.9518 5.45974L19.337 7H20.25C20.6297 7 20.9435 7.28215 20.9932 7.64823L21 7.75C21 8.1297 20.7178 8.44349 20.3518 8.49315L20.25 8.5H19.714L19.922 9.3265C20.5708 9.72128 21.0041 10.435 21.0041 11.25V19.7468C21.0041 20.7133 20.2206 21.4968 19.2541 21.4968H17.75C16.7835 21.4968 16 20.7133 16 19.7468L15.999 18.5H8.004L8.00408 19.7468C8.00408 20.7133 7.22058 21.4968 6.25408 21.4968H4.75C3.7835 21.4968 3 20.7133 3 19.7468V11.25C3 10.4352 3.43316 9.72148 4.08177 9.32666L4.289 8.5H3.75C3.3703 8.5 3.05651 8.21785 3.00685 7.85177L3 7.75C3 7.3703 3.28215 7.05651 3.64823 7.00685L3.75 7H4.663L5.04898 5.46176C5.41068 4.01497 6.71062 3 8.20194 3H15.7993ZM6.504 18.5H4.499L4.5 19.7468C4.5 19.8848 4.61193 19.9968 4.75 19.9968H6.25408C6.39215 19.9968 6.50408 19.8848 6.50408 19.7468L6.504 18.5ZM19.504 18.5H17.499L17.5 19.7468C17.5 19.8848 17.6119 19.9968 17.75 19.9968H19.2541C19.3922 19.9968 19.5041 19.8848 19.5041 19.7468L19.504 18.5ZM18.7541 10.5H5.25C4.83579 10.5 4.5 10.8358 4.5 11.25V17H19.5041V11.25C19.5041 10.8358 19.1683 10.5 18.7541 10.5ZM10.249 14H13.7507C14.165 14 14.5007 14.3358 14.5007 14.75C14.5007 15.1297 14.2186 15.4435 13.8525 15.4932L13.7507 15.5H10.249C9.83478 15.5 9.49899 15.1642 9.49899 14.75C9.49899 14.3703 9.78115 14.0565 10.1472 14.0068L10.249 14H13.7507H10.249ZM17 12C17.5522 12 17.9999 12.4477 17.9999 13C17.9999 13.5522 17.5522 13.9999 17 13.9999C16.4477 13.9999 16 13.5522 16 13C16 12.4477 16.4477 12 17 12ZM6.99997 12C7.55225 12 7.99995 12.4477 7.99995 13C7.99995 13.5522 7.55225 13.9999 6.99997 13.9999C6.4477 13.9999 6 13.5522 6 13C6 12.4477 6.4477 12 6.99997 12ZM15.7993 4.5H8.20194C7.39892 4.5 6.69895 5.04652 6.50419 5.82556L5.71058 9H18.2929L17.4968 5.82448C17.3017 5.04596 16.6019 4.5 15.7993 4.5Z" fill="#7C7C7C"/>
               </svg>
               <span class="ms-3 font-semibold text-sm">{{'admin.My_Vehicle' | translate}}</span>
               <span class="inline-flex ltr:ml-auto rtl:mr-auto">
                  <svg class="svg-arrow-menu transition-all" xmlns="http://www.w3.org/2000/svg" width="9.166" height="5.238" viewBox="0 0 9.166 5.238">
                     <path d="M5.2,8.2a.685.685,0,0,0,0,.968l3.865,3.869a.768.768,0,0,0,1.033,0l3.867-3.867A.684.684,0,1,0,13,8.2L9.581,11.618,6.166,8.2a.683.683,0,0,0-.966,0Z" transform="translate(-4.999 -8)" fill="#7c7c7c"/>
                   </svg>
               </span>
            </a>
         </li> -->

         <li *ngIf="status?.isAPCenabled || status?.isWOQODEenabled">
            <a (click)="closeMenuInMobile()" [routerLink]="'/dashboard/appointment-history' | routeLocalization" class="flex items-center py-[13px] px-[18px] text-[#7C7C7C] rounded-[5px]  hover:bg-gray-100 group" [class.active-item]="isLinkActive('/dashboard/appointment-history')">
               <svg class="w-5 h-5 text-[#7C7C7C] transition duration-75" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 5C12 4.44772 12.4477 4 13 4C13.5523 4 14 4.44772 14 5V11C14 11.5523 13.5523 12 13 12C12.4477 12 12 11.5523 12 11V5Z" fill="#7C7C7C" class="svg-color"/>
                  <path d="M28 5C28 4.44772 28.4477 4 29 4C29.5523 4 30 4.44772 30 5V11C30 11.5523 29.5523 12 29 12C28.4477 12 28 11.5523 28 11V5Z" fill="#7C7C7C" class="svg-color"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 23H12L12 25H14V23ZM12 21C10.8954 21 10 21.8954 10 23V25C10 26.1046 10.8954 27 12 27H14C15.1046 27 16 26.1046 16 25V23C16 21.8954 15.1046 21 14 21H12Z" fill="#7C7C7C" class="svg-color"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M22 23H20L20 25H22V23ZM20 21C18.8954 21 18 21.8954 18 23V25C18 26.1046 18.8954 27 20 27H22C23.1046 27 24 26.1046 24 25V23C24 21.8954 23.1046 21 22 21H20Z" fill="#7C7C7C" class="svg-color"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M30 23H28L28 25H30V23ZM28 21C26.8954 21 26 21.8954 26 23V25C26 26.1046 26.8954 27 28 27H30C31.1046 27 32 26.1046 32 25V23C32 21.8954 31.1046 21 30 21H28Z" fill="#7C7C7C" class="svg-color"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 31H12L12 33H14V31ZM12 29C10.8954 29 10 29.8954 10 31V33C10 34.1046 10.8954 35 12 35H14C15.1046 35 16 34.1046 16 33V31C16 29.8954 15.1046 29 14 29H12Z" fill="#7C7C7C" class="svg-color"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M22 31H20L20 33H22V31ZM20 29C18.8954 29 18 29.8954 18 31V33C18 34.1046 18.8954 35 20 35H22C23.1046 35 24 34.1046 24 33V31C24 29.8954 23.1046 29 22 29H20Z" fill="#7C7C7C" class="svg-color"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 10H33C34.1046 10 35 10.8954 35 12V28C35.6906 28 36.3608 28.0875 37 28.252V12C37 9.79086 35.2091 8 33 8H9C6.79086 8 5 9.79086 5 12V36C5 38.2091 6.79086 40 9 40H28.0703C27.7122 39.381 27.4347 38.7095 27.252 38H9C7.89543 38 7 37.1046 7 36V12C7 10.8954 7.89543 10 9 10Z" fill="#7C7C7C" class="svg-color"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M36 19H6V17H36V19Z" fill="#7C7C7C" class="svg-color"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M35 42C38.3137 42 41 39.3137 41 36C41 32.6863 38.3137 30 35 30C31.6863 30 29 32.6863 29 36C29 39.3137 31.6863 42 35 42ZM35 44C39.4183 44 43 40.4183 43 36C43 31.5817 39.4183 28 35 28C30.5817 28 27 31.5817 27 36C27 40.4183 30.5817 44 35 44Z" fill="#7C7C7C" class="svg-color"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M35 31.1787C35.5523 31.1787 36 31.6264 36 32.1787V36.4768L38.4515 38.1785C38.9052 38.4934 39.0177 39.1165 38.7027 39.5702C38.3878 40.0239 37.7647 40.1364 37.311 39.8215L34 37.5232V32.1787C34 31.6264 34.4477 31.1787 35 31.1787Z" fill="#7C7C7C" class="svg-color"/>
               </svg>

               <span class="ms-3 font-semibold text-sm">{{'admin.Appointment_History' | translate}}</span>
               <!-- <span class="inline-flex ltr:ml-auto rtl:mr-auto">
                  <svg class="svg-arrow-menu transition-all" xmlns="http://www.w3.org/2000/svg" width="9.166" height="5.238" viewBox="0 0 9.166 5.238">
                     <path d="M5.2,8.2a.685.685,0,0,0,0,.968l3.865,3.869a.768.768,0,0,0,1.033,0l3.867-3.867A.684.684,0,1,0,13,8.2L9.581,11.618,6.166,8.2a.683.683,0,0,0-.966,0Z" transform="translate(-4.999 -8)" fill="#7c7c7c"/>
                   </svg>
               </span> -->
            </a>
         </li>

         <!-- <li>
            <a [routerLink]="'/dashboard/woqod-e-tag' | routeLocalization" class="flex items-center py-[13px] px-[18px] text-[#7C7C7C] rounded-[5px]  hover:bg-gray-100 group" [class.active-item]="isLinkActive('/dashboard/woqod-e-tag') || isLinkActive('/dashboard/booking-summary') || isLinkActive('/dashboard/etag-add')">
               <svg class="w-5 h-5 transition duration-75" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.262 16.262">
                  <path fill="none"/>
                  <g transform="translate(2.399 1.399)">
                    <path d="M5.994,4.1a5.547,5.547,0,0,0-4.2,2.556,5.23,5.23,0,0,0,1.115.781h0l.051-.108C3.866,5.5,5.821,5.039,6.568,5.747a1,1,0,0,1,.229.97C6.36,8.093,4.4,8.565,2.77,7.736A4.836,4.836,0,0,1,.04,4.2,4.616,4.616,0,0,0,1.083,7.76,5.243,5.243,0,0,0,5.425,9.447a5.317,5.317,0,0,0,1.353-.3,3.6,3.6,0,0,0,1.49-1.03C9.792,6.32,8.406,4,5.994,4.1M5.6,11.82A2.773,2.773,0,0,1,2.637,9.277,5.373,5.373,0,0,1,1.06,8.239c-.633,2.2.243,4.279,2.472,4.848a4.736,4.736,0,0,0,1.591.086,4.232,4.232,0,0,0,3.714-2.8A4.089,4.089,0,0,1,5.6,11.82M8.745,3.437a2.987,2.987,0,0,0-2.823-.065,3.379,3.379,0,0,1,2.5.424,2.21,2.21,0,0,1,1.2,1.846,1.877,1.877,0,0,0-.878-2.2M9.857,2.214a4.442,4.442,0,0,0-4.2-.1,4.935,4.935,0,0,1,3.781.555,3.281,3.281,0,0,1,1.722,2.82A2.791,2.791,0,0,0,9.857,2.214M11.088.86a6.237,6.237,0,0,0-5.752-.3,7.221,7.221,0,0,1,5.269.829,4.821,4.821,0,0,1,2.463,3.913A3.957,3.957,0,0,0,11.088.86" transform="translate(0 0)" class="svg-color" fill="#7C7C7C"/>
                  </g>
                </svg>                

               <span class="ms-3 font-semibold text-sm">{{'admin.Woqod_E_Tag' | translate}}</span>
            </a>
         </li> -->


         <li *ngIf="loaderEnabledAmount" class="text-center pt-4">
            <div class="w-4 h-4 border-2 border-gray-300 border-t-transparent rounded-full animate-spin mx-auto"></div>
         </li>
         <li *ngIf="isMainAccount && userWalletAmmount?.isSuccess && !currentBalanceStopped && !loaderEnabledAmount">
            <a (click)="closeMenuInMobile()" [routerLink]="'/dashboard/my-wallet' | routeLocalization" class="flex items-center py-[13px] px-[18px] text-[#7C7C7C] rounded-[5px]  hover:bg-gray-100 group" [class.active-item]="isLinkActive('/dashboard/topup-buy') || isLinkActive('/dashboard/confirmation') || isLinkActive('/dashboard/topup-checkout') || isLinkActive('/dashboard/wallet-history') || isLinkActive('/dashboard/wallet-graph') || isLinkActive('/dashboard/my-wallet')">
                <svg class="w-5 h-5 transition duration-75" id="wallet" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
                  <rect id="Rectangle_79494" data-name="Rectangle 79494"  fill="none"/>
                  <path class="svg-color" fill="#7C7C7C" id="wallet-2" data-name="wallet" d="M25.688,3.345a.784.784,0,0,0-.268-.132.808.808,0,0,0-.3-.024.8.8,0,0,0-.287.087.761.761,0,0,0-.23.185l-7.082,8.492H13.6l8.6-10.306A3.8,3.8,0,0,1,23.34.721,3.991,3.991,0,0,1,24.774.285a4.042,4.042,0,0,1,1.5.12,3.923,3.923,0,0,1,1.337.658L35.53,7.087a3.618,3.618,0,0,1,1.395,2.285,3.506,3.506,0,0,1-.592,2.581H32.311l1.4-1.537a.721.721,0,0,0,.15-.254.7.7,0,0,0,.033-.29.7.7,0,0,0-.089-.279.74.74,0,0,0-.2-.224L29.753,6.436l-4.566,5.517H21.273L27.35,4.61ZM4.66,7.57A4.742,4.742,0,0,0,1.4,8.854a4.274,4.274,0,0,0-1.352,3.1V33.139a6.412,6.412,0,0,0,2.028,4.649,7.113,7.113,0,0,0,4.9,1.926H33.122a7.114,7.114,0,0,0,4.9-1.926,6.411,6.411,0,0,0,2.028-4.649V19.989a6.411,6.411,0,0,0-2.028-4.649,7.114,7.114,0,0,0-4.9-1.926H4.66a1.581,1.581,0,0,1-1.088-.428,1.41,1.41,0,0,1,0-2.066,1.581,1.581,0,0,1,1.088-.428h7.046L14.162,7.57ZM27.737,25.1h4.615a1.581,1.581,0,0,1,1.088.428,1.41,1.41,0,0,1,0,2.066,1.581,1.581,0,0,1-1.088.428H27.737a1.581,1.581,0,0,1-1.088-.428,1.41,1.41,0,0,1,0-2.066A1.581,1.581,0,0,1,27.737,25.1Z" transform="translate(-0.045 -0.238)"/>
                </svg>
               <span class="ms-3 font-semibold text-sm">{{'DASHBOARD.WALLET' | translate}}</span>
            </a>
         </li>



         <!-- <li class="mt-auto">
            <button (click)="isSettingEnabled = !isSettingEnabled" type="button" class="flex items-center py-[13px] px-[18px] text-[#7C7C7C] rounded-[5px]  hover:bg-gray-100 group w-full" [class.active-item]="isSettingEnabled">
               <svg class="w-5 h-5 text-[#7C7C7C] transition duration-75" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path class="svg-color-stroke" fill-rule="evenodd" clip-rule="evenodd" d="M11.0175 19C10.6601 19 10.3552 18.7347 10.297 18.373C10.2434 18.0804 10.038 17.8413 9.76171 17.75C9.53658 17.6707 9.31645 17.5772 9.10261 17.47C8.84815 17.3365 8.54289 17.3565 8.30701 17.522C8.02156 17.7325 7.62943 17.6999 7.38076 17.445L6.41356 16.453C6.15326 16.186 6.11944 15.7651 6.33361 15.458C6.49878 15.2105 6.52257 14.8914 6.39601 14.621C6.31262 14.4332 6.23906 14.2409 6.17566 14.045C6.08485 13.7363 5.8342 13.5051 5.52533 13.445C5.15287 13.384 4.8779 13.0559 4.87501 12.669V11.428C4.87303 10.9821 5.18705 10.6007 5.61601 10.528C5.94143 10.4645 6.21316 10.2359 6.33751 9.921C6.37456 9.83233 6.41356 9.74433 6.45451 9.657C6.61989 9.33044 6.59705 8.93711 6.39503 8.633C6.1424 8.27288 6.18119 7.77809 6.48668 7.464L7.19746 6.735C7.54802 6.37532 8.1009 6.32877 8.50396 6.625L8.52638 6.641C8.82735 6.84876 9.21033 6.88639 9.54428 6.741C9.90155 6.60911 10.1649 6.29424 10.2375 5.912L10.2473 5.878C10.3275 5.37197 10.7536 5.00021 11.2535 5H12.1115C12.6248 4.99976 13.0629 5.38057 13.1469 5.9L13.1625 5.97C13.2314 6.33617 13.4811 6.63922 13.8216 6.77C14.1498 6.91447 14.5272 6.87674 14.822 6.67L14.8707 6.634C15.2842 6.32834 15.8528 6.37535 16.2133 6.745L16.8675 7.417C17.1954 7.75516 17.2366 8.28693 16.965 8.674C16.7522 8.99752 16.7251 9.41325 16.8938 9.763L16.9358 9.863C17.0724 10.2045 17.3681 10.452 17.7216 10.521C18.1837 10.5983 18.5235 11.0069 18.525 11.487V12.6C18.5249 13.0234 18.2263 13.3846 17.8191 13.454C17.4842 13.5199 17.2114 13.7686 17.1083 14.102C17.0628 14.2353 17.0121 14.3687 16.9562 14.502C16.8261 14.795 16.855 15.1364 17.0323 15.402C17.2662 15.7358 17.2299 16.1943 16.9465 16.485L16.0388 17.417C15.7792 17.6832 15.3698 17.7175 15.0716 17.498C14.8226 17.3235 14.5001 17.3043 14.2331 17.448C14.0428 17.5447 13.8475 17.6305 13.6481 17.705C13.3692 17.8037 13.1636 18.0485 13.1099 18.346C13.053 18.7203 12.7401 18.9972 12.3708 19H11.0175Z" stroke="#7C7C7C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9747 12C13.9747 13.2885 12.9563 14.333 11.7 14.333C10.4437 14.333 9.42533 13.2885 9.42533 12C9.42533 10.7115 10.4437 9.66699 11.7 9.66699C12.9563 9.66699 13.9747 10.7115 13.9747 12Z" stroke="#7C7C7C" class="svg-color-stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>

               <span class="ms-3 font-semibold text-sm">{{'admin.Settings' | translate}}</span>
               <span class="inline-flex ltr:ml-auto rtl:mr-auto">
                  <svg class="svg-arrow-menu transition-all" xmlns="http://www.w3.org/2000/svg" width="9.166" height="5.238" viewBox="0 0 9.166 5.238">
                     <path d="M5.2,8.2a.685.685,0,0,0,0,.968l3.865,3.869a.768.768,0,0,0,1.033,0l3.867-3.867A.684.684,0,1,0,13,8.2L9.581,11.618,6.166,8.2a.683.683,0,0,0-.966,0Z" transform="translate(-4.999 -8)" fill="#7c7c7c"/>
                   </svg>
               </span>
            </button>
         </li>
         <li *ngIf="isSettingEnabled" class="mt-4 px-[18px]">
            <ul>
               <li class="flex items-center justify-between border-b border-solid border-[#ECECEE] pb-2.5">
                  <span class="text-xs text-[#111111]">{{'admin.Notification' | translate}}</span>
                  <app-switch-blue (onChange)="isNotificationEnabled = $event" [data]="{value: isNotificationEnabled, inputName: 'notification'}"></app-switch-blue>
               </li>
               <li class="flex items-center justify-between mt-2.5 mb-2.5">
                  <span class="text-xs text-[#111111]">{{'admin.SMS_Messages' | translate}}</span>
                  <app-switch-blue (onChange)="isSmsEnabled = $event" [data]="{value: isSmsEnabled, inputName: 'SMS'}"></app-switch-blue>
               </li>
            </ul>
         </li> -->
         <!-- <li>
            <a [routerLink]="'/dashboard/helps' | routeLocalization" class="flex items-center py-[13px] px-[18px] text-[#7C7C7C] rounded-[5px]  hover:bg-gray-100 group" [class.active-item]="isLinkActive('/dashboard/helps')">
               <svg class="w-5 h-5 text-[#7C7C7C] transition duration-75" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path class="svg-color" fill-rule="evenodd" clip-rule="evenodd" d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 7.75C11.3787 7.75 10.875 8.25368 10.875 8.875C10.875 9.28921 10.5392 9.625 10.125 9.625C9.71079 9.625 9.375 9.28921 9.375 8.875C9.375 7.42525 10.5503 6.25 12 6.25C13.4497 6.25 14.625 7.42525 14.625 8.875C14.625 9.83834 14.1056 10.6796 13.3353 11.1354C13.1385 11.2518 12.9761 11.3789 12.8703 11.5036C12.7675 11.6246 12.75 11.7036 12.75 11.75V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V11.75C11.25 11.2441 11.4715 10.8336 11.7266 10.533C11.9786 10.236 12.2929 10.0092 12.5715 9.84439C12.9044 9.64739 13.125 9.28655 13.125 8.875C13.125 8.25368 12.6213 7.75 12 7.75ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="#7C7C7C"/>
              </svg>              
               <span class="ms-3 font-semibold text-sm">{{'admin.Helps' | translate}}</span>
            </a>
         </li> -->

         <li>
         <div *ngIf="isMainAccount && userWalletAmmount?.isSuccess && !currentBalanceStopped && !loaderEnabledAmount" class="sm:hidden mt-4" style="transform: scale(0.92);">
        <div class="flex flex-row" *ngIf="userData?.siteUsersID && userWalletAmmount?.isSuccess && !currentBalanceStopped && !loaderEnabledAmount">
          <div
            class="bg-[#009933] transform ltr:skew-x-[-30deg] rtl:skew-x-[30deg] h-[30px]"
          >
            <div class="ltr:skew-x-[30deg] rtl:skew-x-[-30deg]">
              <p
                [routerLink]="'/dashboard/topup-buy' | routeLocalization"
                (click)="closeMenuInMobile()"
                class="px-5 py-1 tracking-normal text-center underline font-Poppins-Light text-base leading-[25px] text-white cursor-pointer -mt-0.5 rtl:text-[14px] whitespace-nowrap"
              >
                {{ "DASHBOARD.TOPUP" | translate }}
              </p>
            </div>
          </div>

          <div
            class="bg-[#003399] ltr:skew-x-[-30deg] rtl:skew-x-[30deg] h-[30px]"
          >
            <div
              class="ltr:skew-x-[30deg] rtl:skew-x-[-30deg] flex flex-row gap-3 px-3 items-center"
            >
              <p
                class="py-1 tracking-normal font-semibold text-lg text-white mt-[-3px] min-w-[59px] rtl:text-[13px] whitespace-nowrap"
              >
                {{ "CURRENCIES.QR" | translate }}
                  {{ isIconClicked ? formattedAmount : maskedAmount }}
              </p>
              <app-svg
                (click)="toggleIcon()"
                textClass=""
                src="assets/svgs/{{
                  isIconClicked ? 'eye-closed.svg' : 'eye-svgrepo.svg'
                }}"
                customClass="mt-[-3px] flex items-center cursor-pointer"
                label="title_goes_here"
                [stretch]="false"
                width="24"
                height="24"
                stroke="#fff"
              ></app-svg>
            </div>
          </div>
        </div>
          </div>          
         </li>
         
         <li class="sm:mt-auto">
            <a [routerLink]="'/' | routeLocalization" class="flex items-center py-[13px] px-[18px] text-[#7C7C7C] rounded-[5px]  hover:bg-gray-100 group">
<svg class="w-5 h-5 text-[#7C7C7C] transition duration-75" fill="#7C7C7C" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	width="800px" height="800px" viewBox="0 0 495.398 495.398"
	xml:space="preserve">
<g>
	<g>
		<g>
			<path d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
				v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
				c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
				c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"/>
			<path d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
				c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
				c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"/>
		</g>
	</g>
</g>
</svg>
               <span class="ms-3 font-semibold text-sm">{{'DASHBOARD.BACK_TO_WEBSITE' | translate}}</span>
            </a>
         </li>         
        </ul>
     </div>
  </aside>
  <div class="px-3 sm:px-11 pt-4 pb-14 ltr:sm:ml-[263px] rtl:sm:mr-[263px] z-0 relative">
     <div class="mt-[76px] lg:mt-[89px]">
      <div class="sm:hidden pb-4">
         <div class="text-xl font-semibold flex items-center justify-between">
          <span>{{pageTitle | translate}}</span>
            <button *ngIf="isProfilePage" (click)="toggleDDL()" type="button"
            class=" text-[17px] text-[#00904A] font-medium flex justify-end w-auto relative" appClickOutSide
            (appOutsideClick)="isDdlEnabled ? toggleDDL() : ''">
            {{ "DASHBOARD.Actions" | translate }}
            <app-svg src="assets/svgs/arrow.svg" customClass="" label="title_goas_here" [stretch]="false" width="24"
                height="24" stroke="#00904A"></app-svg>
            <div *ngIf="isDdlEnabled"
                class="absolute animate-[fadeInUp_0.3s_ease_both] rtl:left-0 ltr:right-0 top-[40px] rounded-[5px] z-10 overflow-auto w-[162px] max-h-[200px] bg-white shadow-[0px_1px_13px_#0000001A]"
                [class.animate-close]="fireCloseAnimation">
                <ul class="flex flex-col">
                    <li
                        class="px-[15px] relative after:absolute after:border-b after:border-solid after:border-[#E6E6E6] after:bottom-0 after:left-0 after:right-0 after:w-[90%] after:mx-auto ltr:text-left rtl:text-right py-1.5">
                        <button (click)="text()" type="button" class="font-Poppins-Light text-sm leading-[20px] text-[#000000]">
                            {{ "DASHBOARD.EDIT_PROFILE" | translate }}
                        </button>
                    </li>
                </ul>
            </div>
        </button>          
         </div>
         <p class="text-xs text-[#7C7C7C]" *ngIf='pageTitle !== "admin.my-profile"'>{{userDetails?.firstName}} {{userDetails?.lastName}}</p>
     </div>      
      <router-outlet></router-outlet>
     </div>
  </div>



  <app-modal [template]="modalTemplatePlaceholder" [isModalEnabled]="isAnnouncmentModalEnabled"
  (closeModalByKeyboard)="isAnnouncmentModalEnabled = false" modalClasses="w-[90%] max-w-[876px]">
  <ng-template #modalTemplatePlaceholder>
   <div class="offer-banner-container">
      <div class="offer-banner flex-col lg:flex-row pt-[18px] pb-[18px] gap-4 lg:gap-0 ltr:pl-[18px] ltr:lg:pl-[50px] ltr:pr-[18px] rtl:pr-[18px] rtl:lg:pr-[50px] rtl:pl-[18px]">
          <button (click)="isAnnouncmentModalEnabled = false;" type="button" class="close-button ltr:right-[14px] rtl:left-[14px]">
            <svg xmlns="http://www.w3.org/2000/svg" width="16.012" height="16.01" viewBox="0 0 16.012 16.01">
              <path d="M13.41,12l6.3-6.29a1,1,0,1,0-1.42-1.42L12,10.59,5.71,4.29A1,1,0,0,0,4.29,5.71L10.59,12l-6.3,6.29a1,1,0,1,0,1.42,1.42L12,13.41l6.29,6.3a1,1,0,1,0,1.42-1.42Z" transform="translate(-3.994 -3.996)" fill="#fff"/>
            </svg>
          </button>
        
          <div class="offer-content">
            <p class="offer-title">{{announcmentData?.title}}</p>
            <p class="offer-subtitle">{{announcmentData?.subtitle}}</p>
            <p class="offer-description">{{announcmentData?.desc}}</p>
            <a (click)="isAnnouncmentModalEnabled = false;" [routerLink]="announcmentData?.btnLink | routeLocalization" class="offer-button">{{announcmentData?.btnTxt | translate}}</a>
          </div>
        
          <div class="offer-image">
            <img [src]="announcmentData?.img" alt="Vehicle Inspection"/>
          </div>
        </div>
   </div>
  </ng-template>
</app-modal>


</main>